import { Description } from "@mui/icons-material";
import { Box, Divider, Stack, Typography } from "@mui/material";

function JobSeekerCard({
  nmbr,
  text = {},
  description,
  dividerTop = false,
  minWidth = false,
}) {
  return (
    <>
      {dividerTop && (
        <Divider
          sx={{
            height: "60px",
            bgcolor: "transparent",
            // my: "30px",
            border: "none",
            maxWidth: "180px",
          }}
        />
      )}
      <Stack
        id="card"
        direction="column"
        sx={{
          border: "1px solid #CCCCCC",
          borderRadius: "20px",
          maxWidth: "180px",
          minWidth: minWidth ? "270px" : "none",
          alignItems: "center",
          px: "50px",
          py: "25px",
        }}
      >
        <Box
          sx={{
            bgcolor: "#eeecec",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "50%",
            width: "70px",
            height: "70px",
          }}
        >
          <Typography
            sx={{
              fontSize: "24px",
              lineHeight: "22px",
              fontFamily: "Inter",
              fontWeight: "700",
              color: "#000000",
            }}
          >
            {nmbr}
          </Typography>
        </Box>
        <Typography
          sx={{
            fontSize: "24px",
            lineHeight: "28px",
            fontFamily: "Inter",
            fontWeight: "700",
            color: "#0E0B33",
            pb: "10px",
            pt: "20px",
            minWidth: "190px",
            textAlign: "center",
          }}
        >
          {text.one} {<br />} {text.second}
        </Typography>
        <Typography
          sx={{
            fontSize: "14px",
            lineHeight: "22px",
            fontFamily: "Inter",
            fontWeight: "400",
            color: "#4a4866",
            textAlign: "center",
            // maxWidth: "263px",
            maxWidth: "160px",
          }}
        >
          {description}
        </Typography>
      </Stack>
    </>
  );
}

export default JobSeekerCard;
